export { auth } from './chunk-6LYCAMY2.js';
export { JwApiError, jwApi } from './chunk-IDGY2RR5.js';
import './chunk-ZLJPVBZG.js';
export { config } from './chunk-5GSQUAKD.js';

// src/config/apply.ts
async function applyConfig(env) {
  switch (env) {
    case "dev":
      return await import('./env-dev-GEEEVPYP.js');
    case "stg":
      return await import('./env-stg-ELOP6J4P.js');
    case "prd":
      return await import('./env-prd-ISE2AMPZ.js');
  }
}

export { applyConfig };
